import { useEffect } from 'react';
import { useChartContext } from '../components/chart.context';

const PRICE_SCALE_OPTIONS = {
  minimumWidth: 80
};

export const usePriceScaleSynchronization = () => {
  const {
    chartRef,
    indicatorChartRefs,
    chartInitialized,
    data: { indicatorConfigs }
  } = useChartContext();

  useEffect(() => {
    if (chartRef.current && chartInitialized) {
      const mainPriceScale = chartRef.current.priceScale('right');
      mainPriceScale.applyOptions(PRICE_SCALE_OPTIONS);

      indicatorConfigs.subplot.forEach((config) => {
        indicatorChartRefs.current[config.type]?.forEach((indicatorChart) => {
          const priceScale = indicatorChart.priceScale('right');
          priceScale.applyOptions(PRICE_SCALE_OPTIONS);
        });
      });
    }
  }, [indicatorConfigs.subplot, chartInitialized]);
};
